import Vue from 'vue'
import Vuetify from 'vuetify/lib'

Vue.use(Vuetify)
export default new Vuetify({
  icons: {
    iconfont: 'mdiSvg'
  },
  theme: {
    options: {
      customProperties: true
    },
    themes: {
      light: {
        'green-50': '#F2FFF0',
        'green-100': '#D4FFE5',
        'green-200': '#7AFFC2',
        'green-500': '#48E264',
        'green-600': '#3EB856',
        'green-700': '#338E47',
        'green-900': '#1E3A29',

        'red-100': '#FCD5D7',
        'red-500': '#E53935',

        'blue-100': '#D1E5FD',
        'blue-200': '#B8D6FB',
        'blue-500': '#247BEF',

        'yellow-100': '#FEF3CF',
        'yellow-500': '#F4C430',

        'grey-50': '#F4F5F5',
        'grey-200': '#A5ADAC',
        'grey-300': '#8D9796', // tertiary
        'grey-500': '#435554', // secondary
        'grey-700': '#1F3433', // primary
        'grey-900': '#0A211F',
        'grey-background': '#f4f6fa', // background

        'white-0': '#ffffff',
        'white-1': '#ffffff',

        // test mode
        'blue-dark': '#012256',
        'fontDraw-mode': "#8B94A9",
        fontTest: '#6E7A93',
        purpleLight: "#E6E8FC",
        purpleMedium: "#8BAFE8"
      }
    }
  }
})
